/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetFinishedCattleMarketPricesQueryResponse, GetFinishedCattleMarketPricesPathParams, GetFinishedCattleMarketPricesQueryParams, GetFinishedCattleMarketPrices400, GetFinishedCattleMarketPrices401, GetFinishedCattleMarketPrices403, GetFinishedCattleMarketPrices404, GetFinishedCattleMarketPrices409, GetFinishedCattleMarketPrices500, GetFinishedCattleMarketPrices503 } from "../../types/marketPricesController/GetFinishedCattleMarketPrices.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getFinishedCattleMarketPrices } from "../../client/marketPricesController/getFinishedCattleMarketPrices.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getFinishedCattleMarketPricesQueryKey = (organizationId: GetFinishedCattleMarketPricesPathParams["organizationId"] | undefined, params?: GetFinishedCattleMarketPricesQueryParams) => [{ url: '/api/organizations/:organizationId/market-prices/finished-cattle', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type GetFinishedCattleMarketPricesQueryKey = ReturnType<typeof getFinishedCattleMarketPricesQueryKey>

export function getFinishedCattleMarketPricesQueryOptions(organizationId: GetFinishedCattleMarketPricesPathParams["organizationId"] | undefined, params?: GetFinishedCattleMarketPricesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getFinishedCattleMarketPricesQueryKey(organizationId, params)
        return queryOptions<GetFinishedCattleMarketPricesQueryResponse, ResponseErrorConfig<GetFinishedCattleMarketPrices400 | GetFinishedCattleMarketPrices401 | GetFinishedCattleMarketPrices403 | GetFinishedCattleMarketPrices404 | GetFinishedCattleMarketPrices409 | GetFinishedCattleMarketPrices500 | GetFinishedCattleMarketPrices503>, GetFinishedCattleMarketPricesQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getFinishedCattleMarketPrices(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary The published finished-cattle quote (R$/@) for each state the organization's farms are in (optionally one farm via ?establishmentId), plus every other covered state
 * {@link /api/organizations/:organizationId/market-prices/finished-cattle}
 */
export function useGetFinishedCattleMarketPrices<TData = GetFinishedCattleMarketPricesQueryResponse, TQueryData = GetFinishedCattleMarketPricesQueryResponse, TQueryKey extends QueryKey = GetFinishedCattleMarketPricesQueryKey>(organizationId: GetFinishedCattleMarketPricesPathParams["organizationId"] | undefined, params?: GetFinishedCattleMarketPricesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetFinishedCattleMarketPricesQueryResponse, ResponseErrorConfig<GetFinishedCattleMarketPrices400 | GetFinishedCattleMarketPrices401 | GetFinishedCattleMarketPrices403 | GetFinishedCattleMarketPrices404 | GetFinishedCattleMarketPrices409 | GetFinishedCattleMarketPrices500 | GetFinishedCattleMarketPrices503>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getFinishedCattleMarketPricesQueryKey(organizationId, params)
         

         const query = useQuery({
          ...getFinishedCattleMarketPricesQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetFinishedCattleMarketPrices400 | GetFinishedCattleMarketPrices401 | GetFinishedCattleMarketPrices403 | GetFinishedCattleMarketPrices404 | GetFinishedCattleMarketPrices409 | GetFinishedCattleMarketPrices500 | GetFinishedCattleMarketPrices503>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}